







































import {Vue, Component, Prop} from 'vue-property-decorator';
@Component
export default class ColumnItem extends Vue {
  @Prop()
  private gridLayout!: any;
  @Prop()
  private idx!: number;

  private moveItem(type: string) {
    this.$emit('moveItem', {type, idx: this.idx});
  }
}
